// Section 8: Quarrier. 2.0 stone. Pick 1.8x; 6% injury. Heavy job (+0.2 food demand).
// Constants: config.jobs.quarrier, config.needs.heavyJobFoodSurcharge.
import type { Config } from '../../config';
import { alwaysEligible, heavyJobDemand, produced } from '../../core/content-helpers';
import { defineJob } from '../../core/registry';

export function quarrier(config: Config) {
  const c = config.jobs.quarrier;

  return defineJob({
    id: 'quarrier',
    label: 'Quarrier',
    section: 'S8',
    heavy: true,
    output: { kind: 'stock', resource: 'stone' },
    baseYield: c.yield,
    toolFactor: c.toolFactor,
    toolWear: 0,
    risks: { injury: c.injury },
    riskIllness: null,
    requiresBuilding: null,
    minStrength: 0,
    modifierTargets: ['demand'],
    modifierKeys: { demand: ['food'] },
    modifiers: heavyJobDemand('quarrier', config.needs.heavyJobFoodSurcharge),
    produce: (_ctx, _worker, output) => (output > 0 ? [produced('stone', output)] : []),
    eligible: alwaysEligible,
  });
}
